/* affiliate-links.js — DRAFT for nitroapps.io (Phase 1, not deployed). Only rewrites href/rel on <a>. */
(function () {
  'use strict';
  var SHOPIFY = 'https://shopify.pxf.io/en0KyO';   // ONE shared Impact Shopify link, used everywhere, no subIds
  var VANITY = /^https:\/\/shopify\.pxf\.io\/en0KyO\/?$/i;           // legacy vanity link (no subIds possible)
  var SHOPIFY_DEEP = 'https://shopify.pxf.io/c/1288411/1061744/13624'; // + ?u=<theme URL>, one link per Shopify theme
  var ENVATO  = 'https://1.envato.market/c/1288411/275988/4415';    // Impact Envato Market
  // Already-affiliate: Impact domains, Envato, partner/referral params. These links are never touched.
  var AFF_HOST = /(^|\.)(pxf\.io|sjv\.io|envato\.market|shoffi\.app|referralcandy\.com|pixelunion\.net)$|^partners?\.|^affiliate\./i;
  var AFF_PARAM = /[?&](ref|refcode|fpr|aff|affiliate|irclickid|irgwc|r)=/i;
  // Map of third-party app handles to approved partner links (fill in from app-program-map.csv after review).
  // Optional vendor-program overrides (unused; owner decision: all apps.shopify.com links use the Shopify Impact deep link).
  // Legacy theme short links (ours, partner 1288411, but carrying another campaign's subIds and old /styles/ URLs):
  // replaced by the one deep link per theme. PyLQze (free trial) -> shared link. 5b1RaL is NOT ours (irpid 3141857).
  var SHORT_THEME = {"21z4XG": "https://themes.shopify.com/themes/warehouse/presets/warehouse", "EK1o6K": "https://themes.shopify.com/themes/empire/presets/empire", "Kjma2e": "https://themes.shopify.com/themes/dawn/presets/dawn", "PyE5nM": "https://themes.shopify.com/themes/impulse/presets/impulse", "R5qvjg": "https://themes.shopify.com/themes/be-yours/presets/be-yours", "WqrnZG": "https://themes.shopify.com/themes/prestige/presets/prestige", "rQrZV5": "https://themes.shopify.com/themes/symmetry/presets/beatnik", "y2Ad6V": "https://themes.shopify.com/themes/broadcast/presets/broadcast", "zNGEAe": "https://themes.shopify.com/themes/sense/presets/sense", "zNGLdr": "https://themes.shopify.com/themes/focal/presets/focal"};
  var ENVATO_FIX = { '5b1RaL': 'https://themeforest.net/item/roxxe-responsive-multipurpose-shopify-theme/26554507' };
  var APP_PROGRAMS = { /* 'loox': 'https://loox.io/app/The4' */ };

  // One shared link per product: Shopify = SHOPIFY as-is; Envato = ENVATO?u=<product url> (same link on every page).
  function impact(base, dest, deep) {
    return deep && dest ? base + '?u=' + encodeURIComponent(dest) : base;
  }
  function target(url) {
    var h = url.hostname.replace(/^www\./, '');
    if (h === 'shopify.com') {
      // Signup/home/pricing/free-trial only. help., editions, blog, apps. and themes. are not touched.
      if (/^\/(|free-trial|start|pricing|signup)\/?$/.test(url.pathname)) return { base: SHOPIFY, deep: false };
      return null;
    }
    if (h === 'themes.shopify.com' && /^\/themes\/[^/]+/.test(url.pathname))
      return { base: SHOPIFY_DEEP, deep: true };              // one deep link per theme
    if (h === 'themeforest.net' || h === 'codecanyon.net' || h === 'elements.envato.com')
      return { base: ENVATO, deep: true };
    if (h === 'apps.shopify.com')                             // own + third-party apps: one deep link per app
      return { base: SHOPIFY_DEEP, deep: true };
    return null;
  }
  function addRel(a) {
    var rel = (a.getAttribute('rel') || '').split(/\s+/).filter(Boolean);
    ['sponsored', 'nofollow', 'noopener'].forEach(function (r) { if (rel.indexOf(r) < 0) rel.push(r); });
    a.setAttribute('rel', rel.join(' '));
  }
  function stripUtm(u) {
    ['utm_source','utm_medium','utm_campaign','utm_content','utm_term'].forEach(function (k) { u.searchParams.delete(k); });
    return u.toString();
  }
  function run() {
    var links = document.querySelectorAll('a[href]');
    for (var i = 0; i < links.length; i++) {
      var a = links[i], url;
      if (a.dataset.affDone || a.hasAttribute('data-no-affiliate')) continue;
      try { url = new URL(a.href, location.href); } catch (e) { continue; }
      if (url.protocol !== 'https:' && url.protocol !== 'http:') continue;
      if (/^shopify\.pxf\.io$/i.test(url.hostname) && /^\/c\//.test(url.pathname)) {   // /c/ links: keep only u= (per-theme), else shared link
        var u = url.searchParams.get('u'); if (u) u = u.split('?')[0].split('#')[0].replace(/\/+$/, ''); if (u && !/^https?:\/\/(themes|apps)\.shopify\.com\//i.test(u)) u = null;
        a.setAttribute('href', u ? impact(SHOPIFY_DEEP, u, true) : SHOPIFY); addRel(a); a.dataset.affDone = '1'; continue;
      }
      if (/^shopify\.pxf\.io$/i.test(url.hostname)) {             // short links: one link per theme, no subIds
        var code = url.pathname.replace(/^\/|\/$/g, '');
        if (SHORT_THEME[code]) { a.setAttribute('href', impact(SHOPIFY_DEEP, SHORT_THEME[code], true)); addRel(a); a.dataset.affDone = '1'; continue; }
        a.setAttribute('href', SHOPIFY); addRel(a); a.dataset.affDone = '1'; continue;   // en0KyO / PyLQze / unknown -> shared link
      }
      if (/^1\.envato\.market$/i.test(url.hostname) && !/^\/c\//.test(url.pathname)) {
        var ec = url.pathname.replace(/^\/|\/$/g, '');
        a.setAttribute('href', ENVATO_FIX[ec] ? impact(ENVATO, ENVATO_FIX[ec], true) : url.origin + url.pathname); addRel(a); a.dataset.affDone = '1'; continue;
      }
      if (/^1\.envato\.market$/i.test(url.hostname)) {           // /c/ Envato: keep only u=
        var eu = url.searchParams.get('u'); a.setAttribute('href', eu ? impact(ENVATO, eu.split('?')[0], true) : ENVATO); addRel(a); a.dataset.affDone = '1'; continue;
      }
      if (AFF_HOST.test(url.hostname) || AFF_PARAM.test(url.search)) {
        addRel(a);                                            // existing affiliate link: href unchanged, rel completed
        a.dataset.affDone = 'skip'; continue;
      }
      var t = target(url); if (!t) continue;
      a.setAttribute('href', t.direct ? t.direct : impact(t.base, url.origin + url.pathname.replace(/\/+$/, ''), t.deep));
      addRel(a);
      a.dataset.affDone = '1';
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
})();
